import styles from "./WarehouseStock.module.css";

// Cute compact stock indicator that splits availability between the US
// and International warehouses. Accepts the shape returned by
// InventoryController.get():
//   { warehouses: [{ id, label, available }, ...] }
// or a plain { US: n, INTL: n } map.
//
// Renders as a pair of "chips" with a status dot:
//   green  → in stock (>5)
//   amber  → low (1–5)
//   grey   → out / unknown
export default function WarehouseStock({
  availability,
  size = "md",
  showLabel = true,
  layout = "row",
}) {
  const rows = normalize(availability);
  if (!rows.length) return null;
  return (
    <div className={[styles.wrap, styles[size], styles[layout]].join(" ")}>
      {rows.map((r) => {
        const tone = qtyTone(r.available);
        return (
          <div key={r.id} className={[styles.chip, styles[tone]].join(" ")}>
            <span className={styles.flag} aria-hidden>{r.flag}</span>
            <span className={styles.body}>
              {showLabel && <span className={styles.label}>{r.label}</span>}
              <span className={styles.qty}>
                <span className={styles.dot} aria-hidden />
                {qtyText(r.available)}
              </span>
            </span>
          </div>
        );
      })}
    </div>
  );
}

function qtyTone(n) {
  if (n == null) return "unknown";
  if (n <= 0) return "out";
  if (n <= 5) return "low";
  return "ok";
}

function qtyText(n) {
  if (n == null) return "Check stock";
  if (n <= 0) return "Out of stock";
  if (n <= 5) return `${n} left — limited`;
  return `${n} in stock`;
}

function normalize(input) {
  if (!input) return [];
  const meta = {
    US:   { id: "US",   label: "US Warehouse",            flag: "🇺🇸" },
    INTL: { id: "INTL", label: "International Warehouse", flag: "🌎" },
  };
  if (Array.isArray(input.warehouses)) {
    return input.warehouses.map((w) => ({
      ...(meta[w.id] || { id: w.id, label: w.label, flag: "📦" }),
      available: w.available,
    }));
  }
  // Plain map
  const out = [];
  if ("US" in input)   out.push({ ...meta.US,   available: input.US });
  if ("INTL" in input) out.push({ ...meta.INTL, available: input.INTL });
  return out;
}
